var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #feecb0;\n      }\n\n      .cls-2 {\n        fill: #414141;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.24,95.35c0,21.67-11.61,41.22-30.45,51.62v6.33c0,4.44-3.43,8.1-7.78,8.46v5.69c0,4.21-3.42,7.64-7.63,7.64h-26.24c-4.21,0-7.63-3.43-7.63-7.64v-5.69c-4.35-.36-7.78-4.02-7.78-8.46v-6.33c-18.61-10.33-30.45-30.19-30.45-51.62,0-32.51,26.46-58.96,58.98-58.96s58.98,26.45,58.98,58.96Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.27,143.28c-.48,0-.98-.1-1.44-.33-20.53-9.71-33.8-30.65-33.8-53.34,0-32.51,26.46-58.96,58.98-58.96s58.98,26.45,58.98,58.96c0,22.51-12.53,42.74-32.69,52.8-1.67,.83-3.7,.16-4.54-1.52-.83-1.67-.15-3.7,1.52-4.54,17.85-8.91,28.94-26.82,28.94-46.75,0-28.78-23.42-52.19-52.21-52.19s-52.21,23.41-52.21,52.19c0,20.09,11.75,38.62,29.93,47.22,1.69,.8,2.41,2.82,1.61,4.51-.58,1.22-1.79,1.94-3.06,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.03,156.06h-40.06c-4.69,0-8.5-3.81-8.5-8.5v-11.56h57.06v11.56c0,4.69-3.81,8.5-8.5,8.5Zm-41.79-13.29v4.79c0,.95,.78,1.73,1.73,1.73h40.06c.95,0,1.73-.78,1.73-1.73v-4.79h-43.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.12,169.35h-26.23c-4.21,0-7.63-3.42-7.63-7.63v-12.42h41.5v12.42c0,4.21-3.42,7.63-7.63,7.63Zm-27.1-13.29v5.65c0,.48,.39,.87,.87,.87h26.23c.48,0,.87-.39,.87-.87v-5.65h-27.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,142.77c-1.87,0-3.38-1.52-3.38-3.38v-41.99c0-1.87,1.52-3.38,3.38-3.38s3.38,1.52,3.38,3.38v41.99c0,1.87-1.52,3.38-3.38,3.38Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,100.78c-.99,0-1.96-.43-2.63-1.26l-11.32-14c-1.18-1.45-.95-3.58,.5-4.76,1.45-1.18,3.58-.95,4.76,.5l11.32,14c1.18,1.45,.95,3.58-.5,4.76-.63,.51-1.38,.75-2.13,.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,100.78c-.75,0-1.5-.25-2.13-.75-1.45-1.17-1.68-3.31-.5-4.76l11.32-14c1.17-1.46,3.31-1.68,4.76-.5,1.45,1.17,1.68,3.31,.5,4.76l-11.32,14c-.67,.83-1.65,1.26-2.63,1.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.f525e1561cff1c4bb506312d3684370f.svg";
export { ForwardRef as ReactComponent };